// extracted by mini-css-extract-plugin
export var card = "_lz-0";
export var content = "_lz-2";
export var details = "_lz-3";
export var icon = "_lz-1";
export var iconBlue = "_lz-5";
export var iconBrand = "_lz-4";
export var iconGrayBlue = "_lz-6";
export var iconGreen = "_lz-7";
export var iconIndigo = "_lz-8";
export var iconOrange = "_lz-9";
export var iconPurple = "_lz-a";
export var iconRed = "_lz-b";
export var iconWarning = "_lz-c";